// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import Dialog from 'material-ui/Dialog';


class TournamentStructure extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venues: [],
      sub_categories: [],
      game_types: [],
      categories: [],
      AddNewView:props.AddNewView,
      age_groups: [],
      game_formats: [],
      competitions_id:props.competitions_id,
      initialView:props.initialView,
      structure_details : {
              tournament_id: props.id,
              competitions_id:props.competitions_id,
              no_of_teams:0,
              no_of_groups:0,
              no_of_teams_in_each_group:0,
              team_size:0,
              max_player_in_team:0,
              category:'',
              game_type:14,
              format:10,
              age_groups:'',
              type:'',
              format_description:'',
            },
      new_structure_details:[],
      addNewStructureView:false,
      ShowAllStructure:false,
      showStructureView:true,
      selected_struct_id:'',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePricerules = this.handlePricerules.bind(this);
    this.getStructureDetail = this.getStructureDetail.bind(this);
  }


  componentDidMount() {
    this.getTournamentDetails();
    this.getStructureDetail();
  }

 
  getTournamentDetails() {
    if(this.state.initialView){this.setState({addNewStructureView:true})}
    else{this.setState({ShowAllStructure:true})}
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_structure/`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState(
         { venues: data.venues,
           sub_categories: data.sub_categories,
           game_types: data.game_types,
           categories: data.categories,
           age_groups: data.age_groups, 
           game_formats: data.game_formats
         });
        })
       .catch(error => error);
  }

  getStructureDetail(){
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/tournament/get_structure_details/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competitions_id': this.state.structure_details.competitions_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({new_structure_details: data.structure_list}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }



  postCreateStructure() {
    var data = this.state.structure_details
    if(data.no_of_groups > data.no_of_teams || data.no_of_teams_in_each_group > data.no_of_teams || data.team_size > data.max_player_in_team){
                    if(data.no_of_groups > data.no_of_teams){
                      alert("Group can not be more then Teams")
                    }
                    if(data.no_of_teams_in_each_group > data.no_of_teams){
                      alert("Teams per group can not be more then Teams")
                    }
                    if(data.team_size > data.max_player_in_team){
                      alert("Maximum players in team can not be less then team size")
                    }
    }
    else {
            if(!data.format){data.format = 10}
            console.log(data)
            if(data.age_groups == ''){data.age_groups = this.state.age_groups[0].id}
            if(data.no_of_teams_in_each_group == 0){
              data.no_of_teams_in_each_group = Math.ceil(this.state.structure_details.no_of_teams / this.state.structure_details.no_of_groups)
            }
            const url = `${getLocationOrigin()}/tournament/add_tournament_structure/`;
            const options = {...defaultOptions};
            var formData = new FormData();
            options['method'] = 'post';
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({ 
                                                'no_of_team': data.no_of_teams, 
                                                'no_of_group':data.no_of_groups,
                                                'team_per_group':data.no_of_teams_in_each_group,
                                                'team_size':data.team_size,
                                                'max_player':data.max_player_in_team,
                                                'format':data.format,
                                                'competitions_id':data.competitions_id,
                                                'format_description':data.format_description,
                                });
            console.log('Going to fetch');
             return fetch(url, options)
              .then(checkStatus)
              .then(parseJSON)
              .then(function(response){                      // first then()
                  alert(response.message);
                  if(response.success){
                      window.location.reload();
                  }
                })
              .catch(error => {
                console.log(error);
                alert(error.message);
              });
      }

  }

  addMorePricing(){
    console.log("here");
    var pricing_rules =  [...this.state.pricing_rules];
    console.log(pricing_rules);
      pricing_rules.push({id: '', 
                          age_group_id: '', 
                          game_format_id: '', 
                          price: '',});
    this.setState({pricing_rules: pricing_rules});
  }
  handleChangeForNew(event){
    console.log(event.target.name,event.target.value)
    var name = event.target.name
    var new_selected_one =  Object.assign({}, this.state.structure_details);
    new_selected_one[name] = event.target.value
    this.setState({structure_details: new_selected_one});
  }

  handleChange(event,struct_id){
    var name = event.target.name
    var new_selected_one =   this.state.new_structure_details;
    for(var i=0;i<new_selected_one.length;i++){
      var temp_obj = new_selected_one[i];
      if(temp_obj.id == struct_id){
          temp_obj[name] = event.target.value
        }
        console.log(name,event.target.value)
        console.log("value added")
      
    }
  
    this.setState({new_structure_details: new_selected_one}); 
  }
  postSaveStructure(struct_id){
    var new_obj = this.state.new_structure_details;
    var data = {};
    for(var i =0;i<new_obj.length;i++){
        if(new_obj[i].id == struct_id){
          data = new_obj[i];
        }
    }
    if(data.no_of_groups > data.no_of_teams || data.no_of_teams_in_each_group > data.no_of_teams || data.team_size > data.max_player_in_team){
          if(data.no_of_groups > data.no_of_teams){
            alert("Group can not be more then Teams")
          }
          if(data.no_of_teams_in_each_group > data.no_of_teams){
            alert("Teams per group can not be more then Teams")
          }
          if(data.team_size > data.max_player_in_team){
            alert("Maximum players in team can not be less then team size")
          }
    }
    else {
          console.log(data)
          console.log("data collected")
          const url = `${getLocationOrigin()}/tournament/save_tournament_structure/`;
          const options = {...defaultOptions};
          var formData = new FormData();
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({ 
                                              'struct_id':struct_id,
                                              'no_of_team': data.no_of_teams, 
                                              'no_of_group':data.no_of_groups,
                                              'team_per_group':data.no_of_teams_in_each_group,
                                              'team_size':data.team_size,
                                              'max_player':data.max_player_in_team,
                                              'format':data.game_format,
                                              'format_description':data.format_description,
                                              
                              });

          console.log('Going to fetch');
           return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                      // first then()
                alert(response.message);
                this.getStructureDetail();
                this.setState({showStructureView:true});

              })
            .catch(error => {
              console.log(error);
              alert(error.message);
            });
      }
  }


  deleteStructure(id){
    var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/tournament/delete_tournament_structure/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'structure_id': id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => {
                alert(data.message)
                window.location.reload()
            })
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }
  
  handleSubmit(event) {
    event.preventDefault();
    this.postCreateStructure(this.state.structure_details, this.props);
    
  }
  toEditstructureview(struct_id){
    this.setState({showStructureView:!this.state.showStructureView,selected_struct_id:struct_id})
  }
  toAddStructureView(){
    this.setState({addNewStructureView:!this.state.addNewStructureView})
  }
  handlePricerules(key, event){
    const name = event.target.name;
    console.log(event.target.name)
    console.log(event.target.value)
    console.log(key);

    var pricing_rules = [...this.state.pricing_rules];
    
    for (var i=0; i<this.state.pricing_rules.length; i++)
     {
      if (i === key){
        pricing_rules[key][name] = event.target.value;
      }
     }
    this.setState({pricing_rules: pricing_rules});

  }

  render() {
    console.log(this.state);
    console.log("in render");
    return(
      <div className="col-md-12" >
      {this.state.ShowAllStructure && this.state.new_structure_details.length > 0 && this.state.new_structure_details.map((struct,st) => 
        <div className="col-md-12"  >
          <div className="col-md-12" style={{'marginTop':"20px",'marginBottom':"20px",display:'flex',flexDirection:'row'}} >
                                          <div className="col-md-3" >
                                              <div className="heading2" style={styles.heading_div}>Number of Teams</div>
                                              <div  className="heading2" style={styles.heading_div}>Number of Groups</div>
                                              <div  className="heading2" style={styles.heading_div}>Teams per Group</div>
                                          </div>
                                          <div className="col-md-2" >
                                              <div > {struct.no_of_teams ? struct.no_of_teams : "--"}</div>
                                              <div > {struct.no_of_groups ? struct.no_of_groups:"--"}</div>
                                              <div > {struct.no_of_teams_in_each_group ? struct.no_of_teams_in_each_group:"--"}</div>
                                          </div>
                                          <div className="col-md-3" >
                                              <div className="heading2" style={styles.heading_div}>Format </div>
                                              <div  className="heading2" style={styles.heading_div}>Team size</div>
                                              <div  className="heading2" style={styles.heading_div}>Maximum Player in Team</div>
                                          </div>
                                          <div className="col-md-2" >
                                              <div > {struct.game_format == null ? "--" : this.state.categories.map((format,index) => <div>{format[0] === struct.game_format && format[1]}</div>) }</div>
                                              <div > {struct.team_size ? struct.team_size :"--"}</div>
                                              <div > {struct.max_player_in_team ? struct.max_player_in_team :"--"}</div>
                                          </div>
                                          <div className="col-md-2" style={{'textAlign':"right",'padding':"3%"}}>
                                              <input className="button1" type="button" value="Edit"   onClick={() =>{this.toEditstructureview(struct.id)}} />
                                          </div>
          </div>
          <div className="col-md-12" style={{'marginTop':"20px",'marginBottom':"20px"}}>
                                          <div className="col-md-2 heading2" style={styles.heading_div}>Format Description </div>
                                          <div className="col-md-10"> {struct.format_description}</div>
          </div>
          
        
        { !this.state.showStructureView && struct.id == this.state.selected_struct_id &&
          <div className="col-md-12">
                
                <Dialog
                        modal={false}
                        open={!this.state.showStructureView}
                        onClick={() => {this.toEditstructureview()}}
                        autoDetectWindowHeight={true}
                        autoScrollBodyContent={true}
                        scroll={scroll}
                        dividers={scroll === 'paper'}
                      >
                  <div >
                    <div style={styles.main_header} className="col-md-12">
                      Competition Structure
                    </div>
                    
                    <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}> 
                      
                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Format
                        </div>
                        <select name="game_format" className="col-md-5" style={styles.item_body} value={this.state.value} selected={struct.game_format}
                          onChange={(e) =>{ this.handleChange(e,struct.id)}}>
                          {
                            this.state.categories.map((format, index) => (
                            <option key={format} selected={format[0] == struct.game_format && format} value={format[0]}>{format[1]}</option>
                            ))
                          }
                        </select>
                      </div>
                     
                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Number of Teams
                        </div>
                        <input type="number" style={styles.input}  name="no_of_teams" className="required" defaultValue={struct.no_of_teams}
                          value={this.state.value} onChange={(e) =>{ this.handleChange(e,struct.id)}}/>
                        
                      </div>
                       
                       <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Number of Groups
                        </div>
                       <input type="number" style={styles.input} name="no_of_groups" className="required" defaultValue={struct.no_of_groups}
                          value={this.state.value} onChange={(e) =>{ this.handleChange(e,struct.id)}}/>
                      </div>
                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Number of Teams per Group
                        </div>
                       <input type="number" style={styles.input} name="no_of_teams_in_each_group" className="required" defaultValue={struct.no_of_teams_in_each_group}
                          value={this.state.value} onChange={(e) =>{ this.handleChange(e,struct.id)}}/>
                      </div>
                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Team size
                        </div>
                       <input type="number" style={styles.input} name="team_size" className="required" defaultValue={struct.team_size}
                          value={this.state.value} onChange={(e) =>{ this.handleChange(e,struct.id)}}/>
                      </div>
                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Maximum Player in Team
                        </div>
                       <input type="number" style={styles.input} name="max_player_in_team" className="required" defaultValue={struct.max_player_in_team}
                          value={this.state.value} onChange={(e) =>{ this.handleChange(e,struct.id)}}/>
                      </div>
                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Format Description
                        </div>
                          <textarea rows="4" cols="33" style={styles.input}  name="format_description"  defaultValue={struct.format_description}
                          onChange={(e) =>{ this.handleChange(e,struct.id)}} />
                      </div>
                      <div style={styles.button_submit} className="col-md-12">
                          <input className="button1" type="button" value="Save" onClick={() => { struct.id ? this.postSaveStructure(struct.id) :this.postCreateStructure()}} style={styles.input_button}/>
                          {struct.id  && 
                          <input type="button" className="button1" value="Delete" style={styles.delete_button} onClick={()=>{this.deleteStructure(struct.id)}}/>
                          }
                          <input className="button1" type="button" value="Cancel"  style={styles.input_button} onClick={() =>{this.toEditstructureview(struct.id)}} />
                      </div>
                    </form>
                  </div>

                </Dialog>
                </div>
              }
              </div>

      )}
      {this.state.addNewStructureView && 
      
      <div >
        <Dialog
                        modal={false}
                        open={this.state.addNewStructureView}
                        onClick={() => {this.toAddStructureView()}}
                        autoDetectWindowHeight={true}
                        autoScrollBodyContent={true}
                        scroll={scroll}
                        dividers={scroll === 'paper'}
                      >
                  
        <div >
          <div style={styles.main_header} className="col-md-12">
            Add Competition Structure
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}> 
            

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Format
              </div>
              <select name="format" className="col-md-5" style={styles.item_body} value={this.state.value} 
                onChange={(e) =>{ this.handleChangeForNew(e)}}>
                {
                  this.state.categories.map((format, index) => (
                  <option key={format} value={format[0]}>{format[1]}</option>
                  ))
                }
              </select>
            </div>


           
            
   

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Number of Teams
              </div>
              <input type="number" style={styles.input}  name="no_of_teams" className="required"
                value={this.state.value} onChange={(e) =>{ this.handleChangeForNew(e)}}/>
            </div>
             
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Number of Groups
              </div>
             <input type="number" style={styles.input} name="no_of_groups" className="required" 
                value={this.state.value} onChange={(e) =>{ this.handleChangeForNew(e)}}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Number of Teams per Group
              </div>
             <input type="number" style={styles.input} name="no_of_teams_in_each_group" className="required" placeholder={this.state.structure_details.no_of_groups > 0 ? Math.ceil(this.state.structure_details.no_of_teams / this.state.structure_details.no_of_groups) :this.state.structure_details.no_of_teams } 
                 defaultValue={Math.ceil(this.state.structure_details.no_of_teams / this.state.structure_details.no_of_groups)} onChange={(e) =>{ this.handleChangeForNew(e)}}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Team size
              </div>
             <input type="number" style={styles.input} name="team_size" className="required"
                value={this.state.value} onChange={(e) =>{ this.handleChangeForNew(e)}}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Maximum Player in Team
              </div>
             <input type="number" style={styles.input} name="max_player_in_team" className="required"
                value={this.state.value} onChange={(e) =>{ this.handleChangeForNew(e)}}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Format Description
              </div>
                <textarea rows="4" cols="33" style={styles.input}  name="format_description"  placeholder="Enter Format Description"
                onChange={(e) =>{ this.handleChangeForNew(e)}} />
            </div>

 
            <div style={styles.button_submit} className="col-md-12">

              <input className="button1" type="button" onClick={() => {this.postCreateStructure()}} value="Create"/>
              {this.state.AddNewView &&
                <input className="button1" type="button" onClick={() => {this.toAddStructureView()}} value="Cancel" style={{backgroundColor:'red',color:'#ffffff'}}/>
              }
            </div>
            
          </form>
        </div>
        </Dialog>
      </div>
    }
    </div>
    );
  }
}

export default TournamentStructure;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/tournamentStructure/index.js